// extracted by mini-css-extract-plugin
export var article_header = "CtxArticleHeaderSection-module--article_header--59900";
export var article_meta = "CtxArticleHeaderSection-module--article_meta--be4d0";
export var article_metas = "CtxArticleHeaderSection-module--article_metas--8e48d";
export var capitalize = "CtxArticleHeaderSection-module--capitalize--a6f2f";
export var fs14 = "CtxArticleHeaderSection-module--fs-14--62e50";
export var fs16 = "CtxArticleHeaderSection-module--fs-16--b57c5";
export var fs20 = "CtxArticleHeaderSection-module--fs-20--5f25b";
export var fs24 = "CtxArticleHeaderSection-module--fs-24--38a39";
export var fs32 = "CtxArticleHeaderSection-module--fs-32--f7f69";
export var fs40 = "CtxArticleHeaderSection-module--fs-40--c0c62";
export var fsItalic = "CtxArticleHeaderSection-module--fs-italic--a95c4";
export var fsLg = "CtxArticleHeaderSection-module--fs-lg--a98c0";
export var fsMd = "CtxArticleHeaderSection-module--fs-md--c6765";
export var fsNormal = "CtxArticleHeaderSection-module--fs-normal--d6141";
export var fsSm = "CtxArticleHeaderSection-module--fs-sm--15df6";
export var fsXl = "CtxArticleHeaderSection-module--fs-xl--65a19";
export var fsXs = "CtxArticleHeaderSection-module--fs-xs--787ee";
export var fsXxl = "CtxArticleHeaderSection-module--fs-xxl--85a10";
export var fsXxs = "CtxArticleHeaderSection-module--fs-xxs--90a81";
export var fwBold = "CtxArticleHeaderSection-module--fw-bold--0a7c6";
export var fwMedium = "CtxArticleHeaderSection-module--fw-medium--e371b";
export var fwNormal = "CtxArticleHeaderSection-module--fw-normal--dc673";
export var gotham_bold = "CtxArticleHeaderSection-module--gotham_bold--1675d";
export var gotham_bold_italic = "CtxArticleHeaderSection-module--gotham_bold_italic--a6485";
export var gotham_book = "CtxArticleHeaderSection-module--gotham_book--c70c6";
export var gotham_book_italic = "CtxArticleHeaderSection-module--gotham_book_italic--ecd88";
export var lowercase = "CtxArticleHeaderSection-module--lowercase--8d8b5";
export var uppercase = "CtxArticleHeaderSection-module--uppercase--7e5e3";